import React, { useState, useRef } from 'react';
import './vendordashboard.css';
import { useNavigate } from 'react-router-dom';

const Vendordashboard = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [expandedCard, setExpandedCard] = useState(null);
  const [cards, setCards] = useState([
    {
      id: 1,
      title: 'Add Business',
      description: 'Register your business details',
      icon: 'fa-building',
      iconClass: 'business',
      notifications: 0,
      status: 'new',
      progress: 0,
      isPinned: false,
      actions: ['Register New', 'Pricing Plans', 'Import Details', 'View Requirements'],
      detailsContent: 'Complete your business profile to unlock all vendor features. Required information includes business name, address, contact details, and tax information.',
    },
    {
      id: 2,
      title: 'Add a Service',
      description: 'Create new service offerings',
      icon: 'fa-bell',
      iconClass: 'service',
      notifications: 3,
      status: 'active',
      progress: 25,
      isPinned: true,
      actions: ['Create Service', 'Manage Categories', 'Set Pricing'],
      detailsContent: 'Add services that you offer to customers. Include descriptions, pricing, availability, and images to showcase your offerings.',
    },
    {
      id: 3,
      title: 'Track Operations',
      description: 'Monitor your business activities',
      icon: 'fa-truck',
      iconClass: 'operations',
      notifications: 5,
      status: 'attention',
      progress: 65,
      isPinned: false,
      actions: ['View Orders', 'Manage Inventory', 'Schedule Deliveries'],
      detailsContent: 'Monitor daily operations, track orders, manage inventory, and schedule deliveries all from one central dashboard.',
    },
    {
      id: 4,
      title: 'Statistics',
      description: 'View performance analytics',
      icon: 'fa-chart-bar',
      iconClass: 'stats',
      notifications: 1,
      status: 'normal',
      progress: 80,
      isPinned: false,
      actions: ['Sales Report', 'User Analytics', 'View Trends'],
      detailsContent: 'Access comprehensive analytics about your business performance, customer engagement, and sales metrics to make data-driven decisions.',
    }
  ]);
  const [draggingCard, setDraggingCard] = useState(null);
  const cardRefs = useRef({});

  const handleVendorAccount = () => {
    setShowPopup(true);
  };

  const handleProceed = () => {
    setShowPopup(false);
    navigate("/d/add-business");
  };
  const handleAddservice = () =>{
    setShowPopup(false);
    navigate("/d/add-service");
  }

  const handleCancel = () => {
    setShowPopup(false);
  };

  const toggleExpandCard = (id) => {
    if (expandedCard === id) {
      setExpandedCard(null);
    } else {
      setExpandedCard(id);
    }
  };

  const togglePinCard = (e, id) => {
    e.stopPropagation();
    setCards(cards.map(card => 
      card.id === id ? { ...card, isPinned: !card.isPinned } : card
    ));
  };

  const startDragging = (e, id) => {
    setDraggingCard(id);
  };

  const onDragOver = (e) => {
    e.preventDefault();
  };

  const onDrop = (e, targetId) => {
    if (draggingCard === targetId) return;
    
    const cardsCopy = [...cards];
    const draggedCardIndex = cardsCopy.findIndex(card => card.id === draggingCard);
    const targetCardIndex = cardsCopy.findIndex(card => card.id === targetId);
    
    const draggedCard = cardsCopy[draggedCardIndex];
    cardsCopy.splice(draggedCardIndex, 1);
    cardsCopy.splice(targetCardIndex, 0, draggedCard);
    
    setCards(cardsCopy);
    setDraggingCard(null);
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'new': return '#4361ee';
      case 'active': return '#2ec4b6';
      case 'attention': return '#ff9f1c';
      case 'critical': return '#e71d36';
      default: return '#adb5bd';
    }
  };

  const handleQuickAction = (e, action) => {
    e.stopPropagation();
    
    // Handle different actions
    if (action === "Register New") {
      setShowPopup(true); // Show the popup
    } else if (action === "Pricing Plans") {
      navigate("/d/pricing-plans"); // Navigate to pricing plans page

    } else if (action === "Create Service") {
      navigate ("/d/add-service");

    } else {
      // Handle other actions
      console.log(`Action triggered: ${action}`);
      alert(`Action triggered: ${action}`);
    }
  };

  return (
    <div className="vendor-dashboard">
      <div className="dashboard-container">
        <div className="dashboard-header">
          <h1 className="dashboard-title">Vending your business in real-time</h1>
          <p className="dashboard-subtitle">Get insights and manage your services all in one place</p>
        </div>
        
        {/* <div className="text-area-wrapper">
          <div className="text-area-container">
            <textarea
              className="text-input"
              placeholder="Start typing here... (or paste your text)"
            ></textarea>
            <button className="analyze-btn">
              <i className="fa fa-search"></i>
              Analyze
            </button>
          </div>
        </div> */}

        <div className="cards-filter">
          <div className="filter-options">
            <button className="filter-btn active">All</button>
            <button className="filter-btn"  onClick={() => navigate('/d/vendor-profile')} >Profile</button>
            <button className="filter-btn">With Notifications</button>
            <button className="filter-btn"  onClick={() => navigate('/d/vendor-status')} >Status Checker</button>

          </div>
          <div className="view-toggle">
            <button className="view-btn active">
              <i className="fa fa-th-large"></i>
            </button>
            <button className="view-btn">
              <i className="fa fa-list"></i>
            </button>
          </div>
        </div>

        <div className="stats-container">
          {cards.map((card) => (
            <div 
              key={card.id}
              ref={el => cardRefs.current[card.id] = el}
              className={`stat-card ${expandedCard === card.id ? 'expanded' : ''} ${draggingCard === card.id ? 'dragging' : ''}`}
              style={{
                borderLeft: `4px solid ${getStatusColor(card.status)}`
              }}
              onClick={() => toggleExpandCard(card.id)}
              draggable={true}
              onDragStart={(e) => startDragging(e, card.id)}
              onDragOver={onDragOver}
              onDrop={(e) => onDrop(e, card.id)}
            >
              <div className="card-header">
                {card.notifications > 0 && (
                  <div className="notification-badge">
                    {card.notifications}
                  </div>
                )}
                {card.id === 1 && (
                  <div className="tutorial-dot" title="New feature available">
                    <i className="fa fa-circle"></i>
                  </div>
                )}
                <button 
                  className={`pin-button ${card.isPinned ? 'pinned' : ''}`}
                  onClick={(e) => togglePinCard(e, card.id)}
                >
                  <i className={`fa ${card.isPinned ? 'fa-thumbtack' : 'fa-thumbtack'}`}></i>
                </button>
              </div>
              
              <div className="card-content">
                <div className={`card-icon ${card.iconClass}`}>
                  <i className={`fa ${card.icon}`}></i>
                </div>
                <div className="card-text">
                  <h3 className="card-title">{card.title}</h3>
                  <p className="card-description">{card.description}</p>
                  
                  {card.progress > 0 && (
                    <div className="progress-container">
                      <div className="progress-bar">
                        <div 
                          className="progress-fill" 
                          style={{ width: `${card.progress}%`, backgroundColor: getStatusColor(card.status) }}>
                        </div>
                      </div>
                      <span className="progress-text">{card.progress}%</span>
                    </div>
                  )}
                </div>
                <div className="card-action">
                  <span className="card-action-icon">+</span>
                </div>
              </div>
              
              {expandedCard === card.id && (
                <div className="card-details">
                  <p className="details-text">{card.detailsContent}</p>
                  
                  <div className="quick-actions">
                    <h4>Quick Actions</h4>
                    <div className="action-buttons">
                      {card.actions.map((action, index) => (
                        <button 
                          key={index} 
                          className="quick-action-btn"
                          onClick={(e) => handleQuickAction(e, action)}
                        >
                          {action}
                        </button>
                      ))}
                    </div>
                  </div>
                  
                  {card.id === 3 && (
                    <div className="mini-chart">
                      <h4>Recent Activity</h4>
                      <div className="sparkline">
                        <div className="chart-bar" style={{height: '30%'}}></div>
                        <div className="chart-bar" style={{height: '50%'}}></div>
                        <div className="chart-bar" style={{height: '40%'}}></div>
                        <div className="chart-bar" style={{height: '70%'}}></div>
                        <div className="chart-bar" style={{height: '60%'}}></div>
                        <div className="chart-bar" style={{height: '80%'}}></div>
                        <div className="chart-bar" style={{height: '50%'}}></div>
                      </div>
                    </div>
                  )}
                  
                  {card.id === 4 && (
                    <div className="mini-chart">
                      <h4>Performance Overview</h4>
                      <div className="pie-chart">
                        <div className="pie-segment" style={{transform: 'rotate(0deg)', backgroundColor: '#4361ee'}}></div>
                        <div className="pie-segment" style={{transform: 'rotate(90deg)', backgroundColor: '#2ec4b6'}}></div>
                        <div className="pie-segment" style={{transform: 'rotate(220deg)', backgroundColor: '#ff9f1c'}}></div>
                      </div>
                    </div>
                  )}
                  
                  <button className="close-details" onClick={(e) => {
                    e.stopPropagation();
                    setExpandedCard(null);
                  }}>
                    <i className="fa fa-times"></i>
                  </button>
                </div>
              )}
              
              <div className="contextual-help" title="Get help with this feature">
                <i className="fa fa-question-circle"></i>
                <div className="help-tooltip">
                  <p>Click to expand and see more options for {card.title.toLowerCase()}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="genie-density">
          <h2>Genie Marketplace</h2>
          <div className="marketplace-preview">
            <div className="marketplace-stats">
              <div className="marketplace-stat">
                <span className="stat-number">0</span>
                <span className="stat-label">Active Listings</span>
              </div>
              <div className="marketplace-stat">
                <span className="stat-number">0.0%</span>
                <span className="stat-label">Response Rate</span>
              </div>
              <div className="marketplace-stat">
                <span className="stat-number">0.0</span>
                <span className="stat-label">Rating</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Confirmation Popup */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <div className="popup-header">
              <i className="fa fa-building popup-icon"></i>
              <h2>Create Vendor Profile</h2>
            </div>
            <p>Would you like to proceed with creating a vendor profile?</p>
            <div className="popup-buttons">
              <button className="popup-btn proceed" onClick={handleProceed}>
                Proceed
              </button>
              <button className="popup-btn cancel" onClick={handleCancel}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Vendordashboard;